'use strict';

exports.__esModule = true;
var PATIENTS = exports.PATIENTS = {
  GET_PATIENT_DETAILS: {
    LOAD: 'PATIENTS_GET_PATIENT_DETAILS_LOAD',
    SUCCESS: 'PATIENTS_GET_PATIENT_DETAILS_SUCCESS',
    FAIL: 'PATIENTS_GET_PATIENT_DETAILS_FAIL'
  },
  GET_PATIENT_INFO: {
    LOAD: 'GET_PATIENT_INFO_LOAD',
    SUCCESS: 'GET_PATIENT_INFO_SUCCESS',
    FAIL: 'GET_PATIENT_INFO_FAIL'
  },
  FETCH: {
    LOAD: 'PATIENTS_FETCH_LOAD',
    SUCCESS: 'PATIENTS_FETCH_SUCCESS',
    FAIL: 'PATIENTS_FETCH_FAIL'
  },
  SEARCH: {
    LOAD: 'PATIENTS_SEARCH_LOAD',
    SUCCESS: 'PATIENTS_SEARCH_SUCCESS',
    FAIL: 'PATIENTS_SEARCH_FAIL'
  },
  DELETE: {
    LOAD: 'PATIENTS_DELETE_LOAD',
    SUCCESS: 'PATIENTS_DELETE_SUCCESS',
    FAIL: 'PATIENTS_DELETE_FAIL'
  },
  ADD: {
    LOAD: 'PATIENTS_ADD_LOAD',
    SUCCESS: 'PATIENTS_ADD_SUCCESS',
    FAIL: 'PATIENTS_ADD_FAIL'
  },
  EDIT: {
    LOAD: 'PATIENTS_EDIT_LOAD',
    SUCCESS: 'PATIENT_EDIT_SUCCESS',
    FAIL: 'PATIENT_EDIT_FAIL'
  },
  EDIT_PATIENT_DETAILS: {
    LOAD: 'EDIT_PATIENT_DETAILS_LOAD',
    SUCCESS: 'EDIT_PATIENT_DETAILS_SUCCESS',
    FAIL: 'EDIT_PATIENT_DETAILS_FAIL'
  },
  MODAL: {
    DETAILS_TOGGLE: 'PATIENTS_MODAL_DETAILS_TOGGLE',
    DELETE_TOGGLE: 'PATIENTS_MODAL_DELETE_TOGGLE',
    NOTES_TOGGLE: 'PATIENTS_MODAL_NOTES_TOGGLE',
    ADD_PATIENT_TOGGLE: 'ADD_PATIENT_TOGGLE'
  },
  SNACK_BAR: {
    HIDE: 'APPOINTMENTS_SNACK_BAR_HIDE'
  },
  SET_PATIENT_DETAILS: 'SET_PATIENT_DETAILS',
  PROFILE: {
    SET_PATIENT_PROFILE_INFO: 'SET_PATIENT_PROFILE_INFO'
  },
  SET_DELETE_PATIENT_DETAILS: 'SET_DELETE_PATIENT_DETAILS',
  SET_PATIENT_NOTES: 'SET_PATIENT_NOTES',
  PATIENT_LIST: {
    FETCH: 'FETCH_PATIENT_LIST',
    SUCCESS: 'FETCH_PATIENT_LIST_SUCCESS',
    FAIL: 'FETCH_PATIENT_LIST_FAIL'
  }
};

var toggleAddPatientModal = exports.toggleAddPatientModal = function toggleAddPatientModal(isOpened) {
  return {
    type: PATIENTS.MODAL.ADD_PATIENT_TOGGLE,
    isOpened: isOpened
  };
};

var fetchPatients = exports.fetchPatients = function fetchPatients(entityKey) {
  return {
    type: PATIENTS.FETCH.LOAD,
    entityKey: entityKey
  };
};

var fetchPatientsSuccess = exports.fetchPatientsSuccess = function fetchPatientsSuccess(patients) {
  return {
    type: PATIENTS.FETCH.SUCCESS,
    patients: patients
  };
};

var fetchPatientsFail = exports.fetchPatientsFail = function fetchPatientsFail(error) {
  return {
    type: PATIENTS.FETCH.FAIL,
    error: error
  };
};

var getPatientDetails = exports.getPatientDetails = function getPatientDetails(patientKey) {
  return {
    type: PATIENTS.GET_PATIENT_DETAILS.LOAD,
    patientKey: patientKey
  };
};

var getPatientDetailsSuccess = exports.getPatientDetailsSuccess = function getPatientDetailsSuccess(patient) {
  return {
    type: PATIENTS.GET_PATIENT_DETAILS.SUCCESS,
    patient: patient
  };
};

var getPatientDetailsFail = exports.getPatientDetailsFail = function getPatientDetailsFail(error) {
  return {
    type: PATIENTS.GET_PATIENT_DETAILS.FAIL,
    error: error
  };
};

var searchPatients = exports.searchPatients = function searchPatients(query, entitiesKeys) {
  var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'searchBar';
  return {
    type: PATIENTS.SEARCH.LOAD,
    query: query,
    entitiesKeys: entitiesKeys,
    source: source
  };
};

var searchPatientsSuccess = exports.searchPatientsSuccess = function searchPatientsSuccess(patients) {
  return {
    type: PATIENTS.SEARCH.SUCCESS,
    patients: patients
  };
};

var searchPatientsFail = exports.searchPatientsFail = function searchPatientsFail(error) {
  return {
    type: PATIENTS.SEARCH.FAIL,
    error: error
  };
};

var deletePatient = exports.deletePatient = function deletePatient(patientKey) {
  return {
    type: PATIENTS.DELETE.LOAD,
    patientKey: patientKey
  };
};

var deletePatientSuccess = exports.deletePatientSuccess = function deletePatientSuccess(patientKey) {
  return {
    type: PATIENTS.DELETE.SUCCESS,
    patientKey: patientKey
  };
};

var deletePatientFail = exports.deletePatientFail = function deletePatientFail(error) {
  return {
    type: PATIENTS.DELETE.FAIL,
    error: error
  };
};

var addPatient = exports.addPatient = function addPatient(patient, entityKey) {
  return {
    type: PATIENTS.ADD.LOAD,
    patient: patient,
    entityKey: entityKey
  };
};

var addPatientSuccess = exports.addPatientSuccess = function addPatientSuccess(patient, callback, callbackParams) {
  return {
    type: PATIENTS.ADD.SUCCESS,
    patient: patient,
    callback: callback,
    callbackParams: callbackParams
  };
};

var addPatientFail = exports.addPatientFail = function addPatientFail(error) {
  return {
    type: PATIENTS.ADD.FAIL,
    error: error
  };
};

var editPatientDetails = exports.editPatientDetails = function editPatientDetails(patient) {
  return {
    type: PATIENTS.EDIT_PATIENT_DETAILS.LOAD,
    patient: patient
  };
};

var editPatientDetailsSuccess = exports.editPatientDetailsSuccess = function editPatientDetailsSuccess(patient, callback, callbackParams) {
  return {
    type: PATIENTS.EDIT_PATIENT_DETAILS.SUCCESS,
    patient: patient,
    callback: callback,
    callbackParams: callbackParams
  };
};

var editPatientDetailsFail = exports.editPatientDetailsFail = function editPatientDetailsFail(error) {
  return {
    type: PATIENTS.EDIT_PATIENT_DETAILS.FAIL,
    error: error
  };
};

var editPatient = exports.editPatient = function editPatient(patient) {
  return {
    type: PATIENTS.EDIT.LOAD,
    patient: patient
  };
};

var editPatientSuccess = exports.editPatientSuccess = function editPatientSuccess(patient) {
  return {
    type: PATIENTS.EDIT.SUCCESS,
    patient: patient
  };
};

var editPatientFail = exports.editPatientFail = function editPatientFail(error) {
  return {
    type: PATIENTS.EDIT.FAIL,
    error: error
  };
};

var togglePatientDetailsModal = exports.togglePatientDetailsModal = function togglePatientDetailsModal(isOpened) {
  return {
    type: PATIENTS.MODAL.DETAILS_TOGGLE,
    isOpened: isOpened
  };
};

var setPatientDetails = exports.setPatientDetails = function setPatientDetails(patientDetails) {
  return {
    type: PATIENTS.SET_PATIENT_DETAILS,
    patientDetails: patientDetails
  };
};

var setPatientProfileInfo = exports.setPatientProfileInfo = function setPatientProfileInfo(patientDetails) {
  return {
    type: PATIENTS.PROFILE.SET_PATIENT_PROFILE_INFO,
    patientDetails: patientDetails
  };
};

var toggleDeletePatientModal = exports.toggleDeletePatientModal = function toggleDeletePatientModal(isOpened) {
  return {
    type: PATIENTS.MODAL.DELETE_TOGGLE,
    isOpened: isOpened
  };
};
var setDeletePatientDetails = exports.setDeletePatientDetails = function setDeletePatientDetails(patientDetails) {
  return {
    type: PATIENTS.SET_DELETE_PATIENT_DETAILS,
    patientDetails: patientDetails
  };
};

var togglePatientNotesModal = exports.togglePatientNotesModal = function togglePatientNotesModal(isOpened) {
  return {
    type: PATIENTS.MODAL.NOTES_TOGGLE,
    isOpened: isOpened
  };
};

var setPatientNotes = exports.setPatientNotes = function setPatientNotes(notes) {
  return {
    type: PATIENTS.SET_PATIENT_NOTES,
    notes: notes
  };
};
var setPatientsSnackBarAsHidden = exports.setPatientsSnackBarAsHidden = function setPatientsSnackBarAsHidden() {
  return {
    type: PATIENTS.SNACK_BAR.HIDE
  };
};

var fetchPatientList = exports.fetchPatientList = function fetchPatientList(payload) {
  return {
    type: PATIENTS.PATIENT_LIST.FETCH,
    payload: payload
  };
};

var fetchPatientListSuccess = exports.fetchPatientListSuccess = function fetchPatientListSuccess(payload) {
  return {
    type: PATIENTS.PATIENT_LIST.SUCCESS,
    payload: payload
  };
};

var fetchPatientListFail = exports.fetchPatientListFail = function fetchPatientListFail(payload) {
  return {
    type: PATIENTS.PATIENT_LIST.FAIL,
    payload: payload
  };
};

var fetchPatientInfo = exports.fetchPatientInfo = function fetchPatientInfo(payload) {
  return {
    type: PATIENTS.GET_PATIENT_INFO.LOAD,
    payload: payload
  };
};

var fetchPatientInfoSuccess = exports.fetchPatientInfoSuccess = function fetchPatientInfoSuccess(payload) {
  return {
    type: PATIENTS.GET_PATIENT_INFO.SUCCESS,
    payload: payload
  };
};

var fetchPatientInfoFail = exports.fetchPatientInfoFail = function fetchPatientInfoFail(payload) {
  return {
    type: PATIENTS.GET_PATIENT_INFO.FAIL,
    payload: payload
  };
};